import type { FC } from "react";
import React from "react";

import { ButtonCellAction } from "../../index";
import { createTestIdForButtonCellActionElement } from "../../utils/getTestId";

import type { ButtonCellActionDefaultPresetProps } from "../types";

const DEFAULT_PRESET_TEST_ID = createTestIdForButtonCellActionElement("preset");

/**
 * Компоненты пресеты на основе компонента ButtonCellAction с заданными свойствами, в которые необходимо передать текст.
 *
 * <a href="https://www.figma.com/design/64y1aDfl0lSSpek3sq1Lrt/%F0%9F%8D%AC-Cards-%26-Cells-%26-Views?node-id=4615-853218&m=dev" target="_blank">Все пресеты</a>
 */
export const ButtonCellActionDefaultPreset: FC<
    ButtonCellActionDefaultPresetProps
> = ({ label, "data-tsid": tsid, icon, ...restProps }) => {
    const dataTestId = tsid || DEFAULT_PRESET_TEST_ID;

    return (
        <ButtonCellAction {...restProps} data-tsid={dataTestId}>
            <ButtonCellAction.Label>{label}</ButtonCellAction.Label>

            <ButtonCellAction.LeftIcon icon={icon!} />
        </ButtonCellAction>
    );
};
